import { jwtDecode } from "jwt-decode";
export const setLoginCredentials = (username, password) => {
    return {
        username,
        password
    }
}
export const setToken = (loginDetails) => {
    // Saves user token to localStorage
    localStorage.setItem('id_token', loginDetails.token);
    localStorage.setItem('refreshToken', loginDetails.refreshToken);
    localStorage.setItem('scopes', loginDetails["scopes"] !== undefined ? JSON.stringify(loginDetails.scopes) : "");
    localStorage.setItem('corporateId', loginDetails.corporateId);
    localStorage.setItem('permissionType', loginDetails.permissionType);
}
export const getToken = () => {
    // Retrieves the user token from localStorage
    return localStorage.getItem('id_token')
}

export const logout = () => {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('id_token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('scopes');
    localStorage.removeItem('corporateId');
    localStorage.removeItem('permissionType');
}

export const getUserInfo = () => {
    // Using jwt-decode npm package to decode the token
    let userDetails = jwtDecode(getToken());
    if(userDetails["scopes"] === undefined){
        userDetails["scopes"] = JSON.parse(localStorage.getItem('scopes'));
    }
    if(userDetails["corporateId"] === undefined){
        userDetails["corporateId"] = localStorage.getItem('corporateId');
    }
    if(userDetails["permissionType"] === undefined){
        userDetails["permissionType"] = localStorage.getItem('permissionType');
    }
    return userDetails;
}

export const loggedIn = () => {
    // Checks if there is a saved token and it's still valid
    const token = getToken() // GEtting token from localstorage
    return !!token && !isTokenExpired(token) // handwaiving here
}

export const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

